import { render, staticRenderFns } from "./MatriculasIniciaisPorUnidade.vue?vue&type=template&id=09f9d946&scoped=true"
import script from "./MatriculasIniciaisPorUnidade.vue?vue&type=script&lang=js"
export * from "./MatriculasIniciaisPorUnidade.vue?vue&type=script&lang=js"
import style0 from "./MatriculasIniciaisPorUnidade.vue?vue&type=style&index=0&id=09f9d946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f9d946",
  null
  
)

export default component.exports